"use client";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "./API";
import { ServerURL } from "../../Server";
import axios from "axios";

const initialState = {
  token: null,
  tokenExp: null,
  isAuthenticated: false,
  randomNumber: null,
  transactionId: null,
  loginStatus: "",
  loginError: null,
  loginErrorCode: "",
  tokenStatus: "",
  tokenerror: null,
  checkStatusStatus: "",
  checkStatusValue: null,
  checkStatusError: null,
  renewTokenStatus: "",
  renewTokenError: null,
};

export const userLogin = createAsyncThunk(
  "auth/userLogin",
  async ({ id, userType }, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${ServerURL + API.LOGIN}`, {
        id,
        userType,
      });
      return res.data;
      //return res.data.result;
    } catch (err) {
      return rejectWithValue(err.response.data.header.status);
    }
  },
);

export const checkStatus = createAsyncThunk(
  "auth/checkStatus",
  async ({ id, randomNumber, transactionId }, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${ServerURL + API.CHECKSTATUS}`, {
        id,
        randomNumber,
        transactionId,
      });
      return res.data.result;
    } catch (err) {
      return rejectWithValue(err.response.data.header.status);
    }
  },
);

export const generateToken = createAsyncThunk(
  "auth/generateToken",
  async ({ id, randomNumber, transactionId }, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${ServerURL + API.GENERATEJWT}`, {
        id,
        randomNumber,
        transactionId,
      });
      return res.data.result;
    } catch (err) {
      return rejectWithValue(err.response.data.header.status);
    }
  },
);

export const renewToken = createAsyncThunk(
  "auth/renewToken",
  async ({ jwt }, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${ServerURL + API.RENEWTOKEN}`, {
        jwt,
      });
      return res.data.result;
    } catch (err) {
      return rejectWithValue(err.response.data.header.status);
    }
  },
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state, action) => {
      localStorage.removeItem("nonCommitteeToken");
      localStorage.removeItem("nonCommitteeTokenExp");
      sessionStorage.removeItem("hasRefreshed");
      return {
        ...state,
        loginStatus: "",
        isAuthenticated: false,
        randomNumber: null,
        transactionId: null,
        loginError: null,
        token: null,
        tokenExp: null,
        tokenerror: null,
        tokenStatus: "",
        renewTokenStatus: "",
        renewTokenError: null,
      };
    },
    clearStatus: (state, action) => {
      return {
        ...state,
        loginStatus: "",
        tokenStatus: "",
        renewTokenStatus: "",
        checkStatusStatus: "",
        checkStatusValue: null,
      };
    },
    clearErrors: (state, action) => {
      return {
        ...state,
        loginError: null,
        tokenerror: null,
        renewTokenError: null,
        checkStatusError: null,
      };
    },
    setTokenNExp: (state, action) => {
      return {
        ...state,
        token: action.payload.jwtToken,
        tokenExp: action.payload.jwtExp,
      };
    },
  },
  extraReducers: builder => {
    // Login
    builder.addCase(userLogin.pending, state => {
      return {
        ...state,
        loginStatus: "pending",
        isAuthenticated: false,
        randomNumber: null,
        transactionId: null,
        loginError: null,
        token: null,
        tokenerror: null,
        tokenStatus: "",
        loginErrorCode: "",
      };
    });
    builder.addCase(userLogin.fulfilled, (state, action) => {
      if (action.payload.header.status.code === "E600608") {
        return {
          ...state,
          loginStatus: "rejected",
          loginError: action.payload.header.status.description,
          loginErrorCode: "E600608",
        };
      } else if (action.payload) {
        return {
          ...state,
          loginStatus: "success",
          isAuthenticated: true,
          randomNumber: action.payload?.result.randomNumber,
          transactionId: action.payload?.result.transactionId,
          loginError: null,
          loginErrorCode: "",
        };
      } else return state;
    });
    builder.addCase(userLogin.rejected, (state, action) => {
      return {
        ...state,
        loginStatus: "rejected",
        loginError: action.payload?.description,
        isAuthenticated: false,
        randomNumber: null,
        transactionId: null,
      };
    });
    // Check Status
    builder.addCase(checkStatus.pending, state => {
      return {
        ...state,
        checkStatusStatus: "pending",
        checkStatusValue: null,
        checkStatusError: null,
      };
    });
    builder.addCase(checkStatus.fulfilled, (state, action) => {
      if (action.payload) {
        return {
          ...state,
          checkStatusStatus: "success",
          checkStatusValue: action.payload?.status,
          checkStatusError: null,
        };
      } else return state;
    });
    builder.addCase(checkStatus.rejected, (state, action) => {
      return {
        ...state,
        checkStatusStatus: "rejected",
        checkStatusError: action.payload?.description,
        checkStatusValue: null,
      };
    });
    // Generate Token
    builder.addCase(generateToken.pending, state => {
      return {
        ...state,
        tokenStatus: "pending",
        token: null,
        tokenerror: null,
        tokenExp: null,
      };
    });
    builder.addCase(generateToken.fulfilled, (state, action) => {
      if (action.payload) {
        return {
          ...state,
          tokenStatus: "success",
          token: action.payload.jwtToken,
          tokenExp: action.payload.jwtExp,
          tokenerror: null,
        };
      } else return state;
    });
    builder.addCase(generateToken.rejected, (state, action) => {
      return {
        ...state,
        tokenStatus: "rejected",
        token: null,
        tokenExp: null,
        tokenerror: action.payload?.description,
      };
    });
    // Renew Token
    builder.addCase(renewToken.pending, state => {
      return {
        ...state,
        renewTokenStatus: "pending",
        token: null,
        renewTokenError: null,
        tokenExp: null,
      };
    });
    builder.addCase(renewToken.fulfilled, (state, action) => {
      if (action.payload) {
        return {
          ...state,
          renewTokenStatus: "success",
          token: action.payload.jwtToken,
          tokenExp: action.payload.jwtExp,
          renewTokenError: null,
        };
      } else return state;
    });
    builder.addCase(renewToken.rejected, (state, action) => {
      return {
        ...state,
        renewTokenStatus: "rejected",
        token: null,
        tokenExp: null,
        renewTokenError: action.payload?.description,
      };
    });
  },
});
export const { logout, clearStatus, clearErrors, setTokenNExp } =
  authSlice.actions;
export default authSlice.reducer;
